import React, {
  useState,
  useEffect
} from 'react';

interface LoadingEllipsisProps {
  text: string;
}

const LoadingEllipsis = (props: LoadingEllipsisProps): JSX.Element => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? `${prev}.` : ''));
    }, 375);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <span className="c-naa-loading-ellipsis">
      {props.text}
      <span className="c-naa-loading-ellipsis__dots">{dots}</span>
    </span>
  );
};

export default LoadingEllipsis;
